import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["averageRating", "reviewCount", "overallAdjustedRating"],
  _excluded2 = ["sortFields", "limit"];
import { useDataFetchingClient } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SEARCH_ASSETS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { SEARCH_ASSETS_QUERY as PUBLIC_SEARCH_ASSETS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { searchAssets } from '../clients/marketplaceSearchClient';
import { getIsUngatedForAssetSearchChirp } from '../selectors/auth';
function adaptChirpCard(card) {
  const {
      averageRating,
      reviewCount,
      overallAdjustedRating
    } = card,
    rest = _objectWithoutPropertiesLoose(card, _excluded);
  return Object.assign({}, rest, {
    reviewSummary: {
      overallRating: averageRating,
      reviewCount,
      overallAdjustedRating: overallAdjustedRating !== null && overallAdjustedRating !== void 0 ? overallAdjustedRating : null
    }
  });
}
function adaptChirpResponse(response) {
  var _response$cards;
  return {
    total: response.total,
    items: ((_response$cards = response.cards) !== null && _response$cards !== void 0 ? _response$cards : []).map(adaptChirpCard)
  };
}
function toChirpVariables(query) {
  const _ref = query,
    {
      sortFields,
      limit
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  return Object.assign({}, rest, {
    sorts: sortFields !== null && sortFields !== void 0 ? sortFields : [],
    length: limit,
    language: getLang()
  });
}
const EMPTY_CHIRP_RESPONSE = {
  total: 0,
  cards: []
};
export function useAssetSearch(appContext) {
  const useChirp = useSelector(getIsUngatedForAssetSearchChirp);
  const client = useDataFetchingClient();
  const isPublic = appContext === 'public';
  const fetchAssets = useCallback(query => {
    if (!useChirp) {
      return searchAssets(query);
    }
    const dfcQuery = isPublic ? PUBLIC_SEARCH_ASSETS_QUERY : SEARCH_ASSETS_QUERY;
    return client.query({
      query: dfcQuery,
      variables: toChirpVariables(query)
    }).then(({
      data
    }) => {
      var _data$result;
      return [adaptChirpResponse((_data$result = data.result) !== null && _data$result !== void 0 ? _data$result : EMPTY_CHIRP_RESPONSE)];
    });
  }, [useChirp, isPublic, client]);
  return {
    fetchAssets,
    useChirp
  };
}